import React from "react";
import { _cs } from "@togglecorp/fujs";
import styles from "./styles.module.scss";

interface HeaderProps {
  className?: string;
  headingClassName?: string;
  rightComponent?: React.ReactNode;
  title: string;
}

const Header: React.FC<HeaderProps> = ({
  className,
  headingClassName,
  rightComponent,
  title,
}) => (
  <header className={_cs("modal-header", className, styles.header)}>
    <h2
      className={_cs("modal-header-heading", styles.heading, headingClassName)}
    >
      {title}
    </h2>
    {rightComponent}
  </header>
);

export default Header;
